import React from "react";
import { seoDefaults } from "../utils/seoDefaults";
import SEO from "../api/seo";

const PrivacyPolicy = () => {
  return (
    <>
      <SEO {...seoDefaults.privacy} />
      <div className="min-h-screen bg-gray-950 text-white p-8 pt-20">
        <div className="max-w-4xl mx-auto bg-gray-900 rounded-lg shadow-lg p-8 mt-20">
          <h1 className="text-4xl font-bold text-center mb-8 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500">
            Privacy Policy
          </h1>
          <div className="space-y-6 text-gray-300">
            <p>
              Welcome to Game Ztudio. We are committed to safeguarding your
              privacy while you enjoy our products and services. This Privacy
              Policy outlines how we collect, use, and protect your personal
              information.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              1. Information We Collect
            </h2>
            <p>
              We collect personal information you provide to us directly, such
              as when you create an account, place an order, or contact us. This
              includes your name, email address, shipping address, and payment
              details.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              2. How We Use Your Information
            </h2>
            <p>
              We use the information to:
              <ul className="list-disc list-inside ml-4">
                <li>Process orders and payments securely</li>
                <li>Provide customer support</li>
                <li>Improve our website and services</li>
                <li>
                  Send updates, offers, and notifications (with your consent)
                </li>
              </ul>
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              3. Refund Policy
            </h2>
            <p>
              All sales on Game Ztudio are final. We do not offer any refunds
              for products purchased through our website. Please review your
              order carefully before making a payment. Game Ztudio is a brand
              owned and operated by STAR1 HASH (Registered Sole Proprietorship,
              GST No. 33BVBPM9140A1Z2). By completing a purchase, you agree to
              this refund policy.{" "}
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              4. Cancellation Policy
            </h2>
            <p>
              Once an order has been placed on Game Ztudio, it cannot be
              cancelled under any circumstances. Please ensure that you review
              your cart and product details before confirming your purchase.
              Game Ztudio is a brand owned and operated by STAR1 HASH
              (Registered Sole Proprietorship, GST No. 33BVBPM9140A1Z2). By
              placing an order, you agree to this cancellation policy.{" "}
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              5. Cookies and Tracking Technologies
            </h2>
            <p>
              We use cookies to enhance your browsing experience, analyze site
              traffic, and serve targeted advertisements. You can control cookie
              preferences through your browser settings.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              6. Data Security
            </h2>
            <p>
              We implement industry-standard security measures to protect your
              data. However, no method of transmission over the Internet is 100%
              secure.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              7. Your Rights
            </h2>
            <p>
              You have the right to access, correct, or delete your personal
              information. Please contact us at [Your Contact Email] to exercise
              these rights.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              8. Children's Privacy
            </h2>
            <p>
              We do not knowingly collect data from children under 13. If you
              believe your child has provided us with personal information,
              please contact us immediately.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              9. Changes to This Policy
            </h2>
            <p>
              We reserve the right to update this Privacy Policy from time to
              time. Any changes will be posted on this page with the updated
              date.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              10. Contact Us
            </h2>
            <p>
              For any questions or concerns about this Privacy Policy, please
              contact us at <strong> info@gameztudio.com</strong>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
